<template>
  <div class="scrollable-overview">
    <p><strong>Formularz:</strong> {{ lead.formName }}</p>
    <p><strong>Projekt:</strong> {{ lead.projectName }}</p>
    <p><strong>Data wypełnienia:</strong> {{ lead.createdAt }}</p>
    <hr>
    <div v-bind:key="fieldName" v-bind:item="field" v-for="(field, fieldName) in lead.fields">
        <strong>{{ fieldName }}:</strong>
        <pre v-if="field === true">Tak</pre>
        <pre v-else-if="field === false">Nie</pre>
        <pre v-else-if="field">{{ field }}</pre>
        <pre v-else><i>Nie podano</i></pre>
    </div>
    <hr/>
    <div v-bind:key="fieldName" v-bind:item="field" v-for="(field, fieldName) in lead.meta">
      <strong>{{ fieldName }}:</strong>
      <pre v-if="fieldName !== 'user-path'">{{ field }}</pre>
      <pre v-else>{{ field.join("\n") }}</pre>
    </div>
  </div>
</template>
<script>

export default {
  props: ['lead'],
  data () {
    return {}
  },
  name: 'c-lead-overview',
  methods: {
  }
}
</script>
